import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  cantidad: Yup.number().min(1).required(),
  fechaRequerimiento: Yup.string().required()
})
